import {
  VerifyEmailPayload,
  VerifyEmailResponse,
  VerifyOtpPayload,
  verifyEmail as verifyEmailApi,
  verifyOtp as verifyOtpApi,
} from "utils/AxiosUtil";
import type { NetworkType } from "utils/network";

/**
 * The email-OTP gate, shared by card issuance and merchant signup. Not card- or merchant-specific,
 * so it lives on its own rather than in either feature's service module.
 */
async function verifyEmail(
  payload: VerifyEmailPayload,
  network: NetworkType,
): Promise<VerifyEmailResponse> {
  const res = await verifyEmailApi(payload, network);
  return res.data;
}

async function verifyOtp(payload: VerifyOtpPayload, network: NetworkType) {
  const res = await verifyOtpApi(payload, network);
  return res.data;
}

const verification_services = {
  verifyEmail,
  verifyOtp,
};
export default verification_services;
